import { apiClient } from '@/shared/api/http-client';

import type {
    PracticeMemberSettings,
    PracticeMemberSettingsType,
    PracticeMemberSettingsWriteValueOf,
} from '../model/practice-member-settings.types';

export const practiceMemberSettingsApi = {
    getByType: async <T extends PracticeMemberSettingsType>(
        type: T,
        signal?: AbortSignal,
    ): Promise<Extract<PracticeMemberSettings, { type: T }>> => {
        return apiClient.get(`/practice-members/me/settings/${type}`, signal);
    },
    updateByType: async <T extends PracticeMemberSettingsType>(
        type: T,
        value: PracticeMemberSettingsWriteValueOf<T>,
        signal?: AbortSignal,
    ): Promise<void> => {
        return apiClient.patch(`/practice-members/me/settings/${type}`, { value }, signal);
    },
};
